import React, { HTMLAttributes } from 'react';
import { Button as SinkButton } from '@uncinc/uncinc-react-kitchen-sink';
import c from 'classnames';

import './style.scss';

export interface ButtonProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  href?: string;
  inverted?: boolean;
  secondary?: boolean;
  secondarySmall?: boolean
  tertiary?: boolean;
  warning?: boolean;
  asLink?: boolean;
  fullWidth?: boolean;
  icon?: string;
  iconRight?: boolean;
  iconOrientation?: 'left' | 'right' | 'up' | 'down';
  iconOnly?: boolean;
  htmlType?: string;
  buttonState?: '' | 'active' | 'disabled';
  onClick?: () => void;
}

const Button: React.FC<ButtonProps> = ({
  children,
  className,
  href,
  onClick,
  buttonState,
  inverted,
  secondary,
  secondarySmall,
  tertiary,
  warning,
  asLink,
  iconOnly,
  fullWidth,
  icon,
  iconRight,
  iconOrientation,
  htmlType,
  ...props
}) => {
  const classes = c(
    className,
    {
      'Button--primary--inverted': inverted,
      'Button--secondary-small': secondarySmall,
      'Button--secondary--active': buttonState === 'active',
      'Button--secondary': secondary,
      'Button--tertiary': tertiary,
      'Button--disabled': buttonState === 'disabled',
      'Button--full-width': fullWidth,
      'Button--icon-only': iconOnly,
      'Button--warning': warning,
      'Button--as-link': asLink,
    },
  );

  const contentWrapperClassess = c(
    'content-wrapper',
    {
      'icon-before': icon && !iconRight,
      'icon-after': icon && iconRight,
    },
    {
      [`icon-${icon}`]: icon,
      [`icon-orientation-${iconOrientation}`]: iconOrientation,
    },
  );

  return (
    <SinkButton
      primary={!secondary && !tertiary && !secondarySmall && !iconOnly && !warning}
      className={classes}
      href={href}
      htmlType={htmlType}
      onClick={() => {
        if (buttonState === 'disabled' || !onClick) {
          return;
        }

        onClick();
      }}
      {...props}
    >
      <div className={contentWrapperClassess}>
        { children }
      </div>
    </SinkButton>
  );
};

export default Button;
